import { Container, IProps, ISelectItem, useOpenSelector } from 'modules/ui/Select';
import { ClickAwayListener, MenuItem, TextField, Tooltip } from '@mui/material';
import React, { useCallback } from 'react';
import { StyledCombobox } from './styles';
import { DownIcon } from 'assets/icons/withContainer';
import { AutocompleteProps } from '@mui/material/Autocomplete/Autocomplete';
import { ColorVarsEnum } from 'enums/ColorVarsEnum';
import Popper, { PopperProps } from '@mui/material/Popper/Popper';
import { SELECTOR_MENU } from 'modules/workspace/constans';

export interface ComboboxProps extends IProps {
  disableClearable?: boolean;
  tooltipDisableHoverListener?: boolean;
  minWidth?: string;
}

export const Combobox = ({
  name,
  disabled = false,
  tooltipDisableHoverListener = false,
  heightSize = 'normal',
  needBackground = true,
  visibleElements = 10,
  width = '190px',
  onChange,
  options,
  value,
  multiple = false,
  title = '',
  placeholder = '',
  disableClearable,
  minWidth,
}: ComboboxProps) => {
  const { open, toggleOpen, onClickAway } = useOpenSelector();

  const getOptionLabel: (option: ISelectItem) => string = ({ value }) => value;

  const onComboboxChange: AutocompleteProps<ISelectItem, boolean, undefined, undefined>['onChange'] = (_, value) =>
    onChange(value);

  const getPopperStyle = useCallback<(props: PopperProps) => PopperProps['style']>(
    ({ anchorEl }) => ({
      minWidth,
      width: (anchorEl as Element)?.clientWidth || minWidth,
    }),
    [minWidth],
  );

  const PopperComponent = useCallback(
    (props: PopperProps) => <Popper {...props} style={getPopperStyle(props)} />,
    [getPopperStyle],
  );

  return (
    <Container $width={width}>
      {title && <h5>{title}</h5>}
      <ClickAwayListener onClickAway={onClickAway}>
        <StyledCombobox
          sx={{
            '& .MuiInputBase-input.Mui-disabled': {
              WebkitTextFillColor: `var(${ColorVarsEnum.Level_1})`,
            },
          }}
          disabled={disabled}
          multiple={multiple}
          disableClearable={disableClearable}
          onChange={onComboboxChange}
          value={value === '' ? undefined : value}
          open={open}
          onOpen={toggleOpen}
          noOptionsText="Не найдено"
          id={name}
          className="combobox"
          options={options}
          onKeyDown={(e) => e.stopPropagation()}
          renderInput={(params) => <TextField {...params} placeholder={placeholder} />}
          renderOption={(props, options) => (
            <Tooltip disableHoverListener={tooltipDisableHoverListener} title={options.name} placement="left">
              <MenuItem {...props}>
                <div>{options.value}</div>
              </MenuItem>
            </Tooltip>
          )}
          componentsProps={{
            popper: { className: SELECTOR_MENU, placement: 'bottom-start' },
          }}
          PopperComponent={PopperComponent}
          getOptionLabel={getOptionLabel}
          popupIcon={<DownIcon />}
          $heightSize={heightSize}
          $width={width}
          $needBackground={needBackground}
          $visibleElements={visibleElements}
        />
      </ClickAwayListener>
    </Container>
  );
};
